module.exports = __webpack_public_path__ + "img/16.e3be159f.webp";